import React from 'react'

const ConfirmBooking = () => {
  return (
    <>
    <h1>Your reservation has been confirmted</h1>
    <h2>We look forward to serving you</h2>
    </>
  )
}

export default ConfirmBooking;